import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { SalemanApi, SalemanDataType } from "@/api/SalemenApi";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { showAlert } from "@utils/Alert";
import { useAdminContext } from "@/hooks/useAdminContext";

const SalesmanIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);
  const { adminTenantId, isAdminMode, profileBackUrl, adminQuerySuffix } = useAdminContext();

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await SalemanApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'El Vendedor no puedo ser eliminado');
    } else {
      showAlert('success', 'El Vendedor fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  const fetchData = (...args: any[]) =>
    isAdminMode ? SalemanApi.fetchAllByOwnerId(adminTenantId!) : SalemanApi.fetchAll(...args);

  return (
    <PageContainer
      title="Vendedores"
      backUrl={profileBackUrl}
      primaryActions={[
        {
          onClick: () => {
            navigate(`/user/saleman${adminQuerySuffix}`)
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<SalemanDataType>
        ref={modelRef}
        fetchData={fetchData}
        filterProps={[
          {
            key: "codigo",
            filterType: "eq",
            type: "number"
          },
          {
            key: "nombre",
            filterType: "contains"
          }
        ]}
        secondaryProperties={[
          {
            key: "codigo",
          },
          {
            key: "nombre"
          }
        ]}
        listActions={[
          {
            href: `/user/saleman/{:id}${adminQuerySuffix}`,
            actionTitle: "Editar Vendedor",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Vendedor",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Vendedor",
              confirmMessage: "¿Seguro que desea eliminar este Vendedor?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default SalesmanIndex;
